import { createContext } from 'react';

import { createContextualCan } from '@casl/react';

// @local
import { buildAbilityFor } from './ability';

export const AbilityContext = createContext(buildAbilityFor('none'));
export default createContextualCan(AbilityContext.Consumer);
